import ModalEvaporator from './ModalEvaporator';

export default ModalEvaporator;
